import React from 'react'
import { TextField } from '@mui/material'
import { DateRangePicker, DateRangePickerProps } from '@mui/x-date-pickers-pro'
import { FormItem } from 'hic-components'

type HicDateRangePickerProps = DateRangePickerProps<Date | undefined> & {
  start: {
    startLabel?: string
    startTooltip?: string
    startPlaceholder?: string
    startDateError?: string
    maxWidth?: string
  }

  end: {
    forceLabelMargin?: boolean
    endLabel?: string
    endTooltip?: string
    endPlaceholder?: string
    endDateError?: string
    maxWidth?: string
  }

  controlled?: {
    open: boolean
    setOpen: () => void
    setClose: () => void
  }

  fieldError?: string
  fieldSmall?: true
}

export default function HicDateRangePicker(props: HicDateRangePickerProps) {
  const { start, end, controlled, fieldError, fieldSmall, ...otherProps } = props
  const { startDateError, startLabel, startTooltip, startPlaceholder } = start
  const { endDateError, endLabel, endTooltip, endPlaceholder, forceLabelMargin } = end

  return (
    <DateRangePicker
      open={controlled?.open}
      onClose={controlled?.setClose}
      onOpen={controlled?.setOpen}
      slots={{ textField: TextField }}
      slotProps={{
        textField: (props) => ({
          InputProps: { label: '' /*, hiddenLabel: true*/ },
          InputLabelProps: { sx: { pb: 0, mb: '0px !important', lineHeight: '1.57 !important' } },
          label: props.position === 'start' ? <FormItem fieldLabel={startLabel} fieldTooltip={startTooltip} /> : <FormItem fieldLabel={endLabel} fieldTooltip={endTooltip} />,
          hiddenLabel: true,
          size: fieldSmall ? 'small' : undefined,
          sx: {
            maxWidth: props.position === 'start' && start.maxWidth ? start.maxWidth : end.maxWidth ? end.maxWidth : undefined,
            ml: props.position === 'end' ? '8px !important' : undefined,
          },
          placeholder: props.position === 'start' ? startPlaceholder : endPlaceholder,
          helperText: props.position === 'start' && startDateError ? startDateError : endDateError ? endDateError : undefined,
        }),
        fieldSeparator: { sx: { display: 'none' } },
      }}
      {...otherProps}
    />
  )
}
